module.exports = __webpack_public_path__ + "static/media/loading.b6ca002c.svg";